import { useEffect, useRef } from "react";
import { previewConfig, type PuzzleCopy } from "./config";

/**
 * The setup shown when a puzzle opens: who Susie is talking to, what she needs,
 * and what the player is being asked to work out. Dismissed with the button or
 * Escape, and reachable again from the "Briefing" button on the puzzle screen —
 * the scenario carries the numbers you need, so it has to be re-readable.
 *
 * The puzzle loads behind it, so it's ready to play the moment this closes.
 */
export function PuzzleBriefing({
  copy,
  onStart,
}: {
  copy: PuzzleCopy;
  onStart: () => void;
}): React.ReactElement {
  const startRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    startRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onStart();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onStart]);

  return (
    <div className="preview-briefing" role="dialog" aria-modal="true" aria-label={copy.name}>
      <div className="preview-briefing__card">
        <h2 className="preview-briefing__title">{copy.name}</h2>
        {copy.briefing.map((para) => (
          <p key={para.slice(0, 40)} className="preview-briefing__para">
            {para}
          </p>
        ))}
        <button ref={startRef} className="preview-briefing__start" onClick={onStart}>
          {previewConfig.startLabel}
        </button>
      </div>
    </div>
  );
}
